module.exports = __webpack_public_path__ + "static/5-e57805a8a1347c7658d1dd1459da9e63.jpg";